// extracted by mini-css-extract-plugin
export default {"container":"aRK2L7fGC0UlgW47IRbp"};